import type { WLT } from "./types";

// hasResults reports whether any row has played a game in this record.
// A column that is 0-0-0 on every row says nothing, so the table drops it.
// Neutral is the usual case: the scoreboard publishes no neutral-site flag.
export function hasResults<T>(rows: T[], record: (row: T) => WLT): boolean {
  return rows.some((row) => {
    const r = record(row);
    return r.wins + r.losses + r.ties > 0;
  });
}
